/**
 * Panda types a slot recipe's result as `Partial<Record<Slot, string>>`, but its runtime always
 * returns a class name for every declared slot (the recipe config lists them). This narrows the
 * type so slot classes can be passed where a `string` is required.
 */
export function slots<Slot extends string>(
  classes: Partial<Record<Slot, string>>,
): Record<Slot, string> {
  // Safe: Panda's slot recipe runtime fills every slot of the recipe (see the doc comment).
  return classes as Record<Slot, string>;
}
